import backgroundImage from "../../common/assets/homePageBackground.png";

const drawerWidth = 240;

const styles = theme => ({
  root: {
    backgroundImage: `url(${backgroundImage})`,
    display: "flex",
    height:'100vh',
    minWidth:1400,
  },
  backdrop: {
    zIndex: 10001,
    color: '#fff',
  },
  bottomIcons: {
    position: 'absolute',
    bottom: 40,
    right: 0,
    left: 0,
  },
  confirmButton:{
    width:'60%',
  },
  createRideButton: {
    width: "79%",
  },
  datePicker: {
    display:'flex',
    justifyContent: "flex-end",
    paddingRight: 100
  },
  datePickerButtons: {
    display: "flex",
    justifyContent: "space-around"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap"
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1
    }
  },
  errorMessage: {
    color: '#f44336',
  },
  flex:{
    display:'flex',
  },
  leftPanel: {
    width: 650
  },
  leftPanelContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '87vh',
    overflow: 'hidden',
  },
  panelContainer: {
    minWidth: 1300,
    height:'100vh',
    width: "100vw",
    alignItems: "flex-end",
    justifyContent: "space-between"
  },
  toolbar: {
    alignItems: "center",
    flexDirection:"column",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1.5),
    marginTop:20,
    ...theme.mixins.toolbar
  },
  leftMenuIcons:{
    flexDirection:'column',
    marginTop:10,
  },
  none:{
    display:'none',
  },
  tabs: {
    position: 'sticky',
    top: 0,
  },
});

export default styles;
